<template>
  <div>
    <div class="vx-row mt-4">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <label>Tipo Documento</label>
        <v-select
          v-model="documentType"
          :options="documentTypeList"
          label="name"
          class="required-select"
        >
          <div slot="no-options">Nenhum registro encontrado!</div>
        </v-select>
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('account_type')"
        >{{ errors.first('account_type') }}</span> -->
      </div>
    </div>

    <div class="vx-row mb-6" v-if="documentType != null">
      <div class="vx-col w-full">
        <vue-dropzone
          id="upload"
          ref="fileUploadZone"
          v-on:vdropzone-success="success"
          v-on:vdropzone-sending="sending"
          v-on:vdropzone-error="error"
          v-on:vdropzone-file-added="added"
          v-on:vdropzone-queue-complete="complete"
          :use-font-awesome="true"
          :options="dropzoneOptions"
          :use-custom-dropzone-options="true"
          :max_number_of_files="10"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">Arraste e solte para enviar os arquivos!</h3>
            <div class="subtitle">...ou selecione um arquivo do seu computador.</div>
          </div>
        </vue-dropzone>
      </div>
    </div>

    <div v-if="documentList.length > 0">
      <vs-table :data="documentList" no-data-text="Nenhum registro encontrado">
        <template slot="thead">
          <vs-th>Arquivo</vs-th>
          <vs-th>Tipo Documento</vs-th>
          <vs-th>Data</vs-th>
          <vs-th>Tamanho</vs-th>
          <vs-th>Ação</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="flex items-center">
              <img :src="icon(data[indextr].file)" width="34" />
            </vs-td>
            <vs-td>{{data[indextr].document_type.name}}</vs-td>
            <vs-td>{{data[indextr].file.created_at_formatted}}</vs-td>
            <vs-td>{{data[indextr].file.human_readable_size}}</vs-td>
            <vs-td style="cursor: pointer;">
              <feather-icon
                v-permission="'files.preview'"
                icon="EyeIcon"
                class="h-5 w-5 mb-1 mr-3 stroke-current text-success"
                v-if="showPreviewButton(data[indextr].file)"
                @click="showPreview(data[indextr].file)"
              />
              <feather-icon
                v-permission="'files.download'"
                icon="DownloadIcon"
                class="h-5 w-5 mb-1 mr-3 stroke-current text-success"
                v-else
                @click="showPreview(data[indextr].file)"
              />
              <feather-icon
                v-permission="'files.download'"
                icon="DownloadIcon"
                class="h-5 w-5 mb-1 mr-3 stroke-current text-success"
                v-if="showPreviewButton(data[indextr].file)"
                @click="download(data[indextr].file)"
              />
              <feather-icon
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-3 stroke-current text-danger"
                @click="destroy(data[indextr])"
                title="Excluir"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- DOCUMENT PREVIEW POPUP -->
    <vs-popup title="Visualizar Documento" :active.sync="previewImage">
      <img
        :src="previewImage"
        class="flex items-center"
        style="margin: 0 auto; max-width: 100%; max-height: 100%;"
      />
    </vs-popup>

    <vs-popup title="Visualizar Documento" :active.sync="previewObject">
      <object
        :data="previewObject"
        :type="previewObjectType"
        width="100%"
        height="100%"
        style="height: 60vh;"
      ></object>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import standard from '@/services/standard'
import {mimeType} from '@/util/Util'
import MediaService from '@/services/api/MediaService'

import pdf from '@/assets/images/file-icons/pdf.png'
import xls from '@/assets/images/file-icons/xls.png'
import doc from '@/assets/images/file-icons/doc.png'
import video from '@/assets/images/file-icons/video.png'
import generic from '@/assets/images/file-icons/generic.png'

export default {
  components: {
    vSelect,
    vueDropzone: vue2Dropzone
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    personType: {
      type: String,
      default: 'PF'
    }
  },
  data: () => ({
    id: null,
    parentEntity: null,
    documentType: null,
    documentTypeList: [],
    dropzoneOptions: {
      url: `${process.env.VUE_APP_API_BASE_URL}/api/v1/document_people/document_upload`,
      addRemoveLinks: true,
      headers: { Authorization: `Bearer ${standard.token()}` },
      acceptedFiles:
        'image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.ms-excel,application/zip,application/vnd.ms-powerpoint,application/x-tar,application/x-tex,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    documentList: [],
    previewImage: null,
    previewObject: null
  }),
  computed: {
    validateForm() {
      return this.documentType !== null
    }
  },
  watch: {},
  methods: {
    icon(file) {
      if (!file) return generic
      const iconPath = '@/assets/images/file-icons'
      const type = mimeType(file.mime_type)
      if (file.mime_type.startsWith('video')) {
        return video
      } else if (type === 'doc' || type === 'docx' || type === 'dot') {
        return doc
      } else if (type === 'pdf') {
        return pdf
      } else if (file.mime_type.startsWith('image')) {
        return file.url
      } else if (type === 'xlb' || type === 'xls' || type === 'xlsx') {
        return xls
      } else {
        return generic
      }
    },
    destroy(data) {
      this.dataToDestroy = data
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(data)
        }
      })
    },
    acceptDestroy(data) {

      this.$vs.loading()
      this.services.documentPeopleService
        .destroy({
          id: data.id
        })
        .then(
          response => {
            this.$vs.loading.close()

            this.$vs.notify({
              title: 'Successo!',
              text: 'Operação realizada com sucesso.',
              color: 'success',
              iconPack: 'feather',
              position: 'top-center',
              icon: 'icon-check-circle'
            })

            this.documentList = this.documentList.filter(element => {
              return element.id !== data.id
            })
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    showPreviewButton(media) {
      return (
        media.mime_type.startsWith('image') ||
        media.mime_type.startsWith('video') ||
        media.mime_type === 'application/pdf'
      )
    },
    showPreview(media) {
      const type = mimeType(media.mime_type)
      if (media.mime_type.startsWith('video') || type === 'pdf') {
        this.previewObject = media.url
        this.previewObjectType = media.mime_type
      } else if (media.mime_type.startsWith('image')) {
        this.previewImage = media.url
      } else {
        window.open(media.url, '_blank')
      }
    },
    download(media) {
      this.$vs.loading()
      const mediaService = MediaService.build(this.$vs)
      mediaService
        .download(`${media.id}/download`, media.file_name, media.mime_type)
        .then(
          data => {
            this.$vs.loading.close()
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    /** Dropzone **/
    success(file) {
      // this.$refs.fileUploadZone.processQueue()
      const response = JSON.parse(file.xhr.response)
      this.documentList.push(response)
    },
    sending(file, xhr, formData) {
      formData.append('document_type_id', this.documentType.id)
      formData.append('people_id', this.parentEntity.people.id)
    },
    cancel() {
      this.removeAllFiles()
    },
    removeAllFiles() {
      this.$refs.fileUploadZone.removeAllFiles()
    },
    error(file) {
      if (file.status === 'error') {
        this.notifyError(this.$vs, file.xhr.response)
        this.removeAllFiles()
      }
    },
    added(file) {
      file['key'] = this.getFilenameIndex(file.name)
    },
    complete(file, xhr, formData) {
      this.removeAllFiles()
    },
    getFilenameIndex(name) {
      const res = name.replace(' ', '_')
      return res.replace(/[^0-9a-zA-Z]/g, '')
    }
  },
  beforeMount() {
    this.$vs.loading()
    this.services.documentTypeService
      .get('', { person_type: this.personType })
      .then(
        data => {
          this.documentTypeList = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
  },
  mounted() {
    this.$root.$on('naturalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['naturalEntity/naturalEntity']
      this.documentList = Array.from(this.parentEntity.people.documents)

      this.documentList = this.documentList.filter(document => {
        return document.media.length > 0
      })

      this.documentList.forEach(document => {
        document['file'] = document.media.length > 0 ? document.media[0] : null
      })
    })

    this.$root.$on('legalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['legalEntity/legalEntity']
      this.documentList = Array.from(this.parentEntity.people.documents)

      this.documentList = this.documentList.filter(document => {
        return document.media.length > 0
      })

      this.documentList.forEach(document => {
        document['file'] = document.media.length > 0 ? document.media[0] : null
      })
    })
  }
}
</script>